import React, {  } from "react";
import classNames from "classnames";

interface ReservationCalendarLegendProps {
   className?: string
}
export const ReservationCalendarLegend: React.FC<ReservationCalendarLegendProps> = ({ className }) => {
   return (<div className={classNames("reservation-calendar-legend", className)}>
      {[
         ["Closed", "rcl-item-closed"],
         ["Booked", "rcl-item-booked"],
         ["Available", "rcl-item-available"],
         ["Your Reservation", "rcl-item-own"]
      ].map(legend => (<div key={legend[1]} className={classNames("rcl-item", legend[1])}>{legend[0]}</div>))}
   </div>)
}